import styled, { css } from 'styled-components';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../global/commonStyle';
import { Typography } from '../../global/theme';

const ScreenRecordMain = styled.div`
  .e-rte-video .e-video-inline {
    width: 355px;
  }
  .video-preview {
    border-radius: var(--border-radius-6);
    padding: var(--space-6) var(--space-0);
    gap: var(--space-12);
    flex-direction: row-reverse;
    justify-content: flex-end;
    border: none;
    max-width: unset;
    :last-child {
      padding-bottom: var(--space-0);
    }
    .screen-recording-name {
      ${Typography.body_md_medium};
    }
    .screen-recording-header {
      padding: var(--space-0);
      border-bottom: none;
    }
    .inbox-video {
      width: 86px;
      height: 72px;
      border-radius: var(--border-radius-4);
      border: 0.5px solid var(--border-primary);
    }
  }
  .header {
    ${AlignCenter}
    gap: var(--space-6);
  }
`;

const Printscreen = styled.div`
  width: fit-content;
  border-radius: var(--border-radius-8);
  padding-block: var(--space-6);
  background-color: var(--background-primary);
  :last-child {
    padding-bottom: var(--space-0);
  }
  .prnt-screen-box {
    flex-direction: row-reverse;
    gap: var(--space-12);
    -webkit-box-align: center;
    align-items: center;
  }
  .prnt-screen-header {
    padding: var(--space-0);
    border-bottom: none;
  }
  .prnt-screen-text {
    display: flex;
    flex-direction: column;
    gap: var(--space-12);
  }
  .logo {
    width: 20px;
    height: 20px;
  }
  .header {
    ${AlignCenter}
    gap: var(--space-6);
  }
  .buttons {
    display: flex;
    gap: var(--space-12);
    ${mobile_xl(css`
      flex-direction: column;
      width: max-content;
    `)}
  }
  a {
    text-decoration: none;
  }
  .custom-mask-content {
    height: 28px;
  }
`;
const SvgDiv = styled.div`
  ${FlexCenter}
  .img-cleanShot {
    width: 20px;
    height: 20px;
  }
`;

export { ScreenRecordMain, Printscreen, SvgDiv };
